import { IntegrationCategoryModel } from "../../models";

import { mockRouteModel } from ".";

export function mockIntegrationCategoryModel({
    id = "integration-category-1234",
    type = "integrationCategory",
    locale = "en",
    content = mockIntegrationCategoryModelContent()
}: Partial<IntegrationCategoryModel> = {}): IntegrationCategoryModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type IntegrationCategoryModelContent =
    IntegrationCategoryModel["content"];

export function mockIntegrationCategoryModelContent({
    entryTitle = "Example Integration Category",
    title = "Lorem ipsum",
    route = mockRouteModel(),
    ...optionals
}: Partial<IntegrationCategoryModelContent> = {}): IntegrationCategoryModelContent {
    return {
        entryTitle,
        title,
        route,
        ...optionals
    };
}
